export const addLeadingZeros = ({
  value,
  finalLength = 2,
}: {
  value: string | number
  finalLength?: number
}) => value.toString().padStart(finalLength, '0')
